import request from './request'

request.defaults.baseURL = process.env.BASE_USER_API

export function getApiToken(timestamp) {
  return request({
    url: '/ucenter/api/v1/user/getToken.nse',
    method: 'post',
    params: { timestamp }
  })
}

export function getResToken(account) {
  return request({
    url: '/ucenter/obs/getToken.nse',
    method: 'post',
    params: { account }
  })
}

export function login(data) {
  return request({
    url: '/ucenter/api/v1/user/login.nse',
    method: 'get',
    params: data
  })
}

// sso登录
export function ssoLogin(data) {
  return request({
    url: '/sso/4.0/sso/login',
    method: 'post',
    data
  })
}

// 获取图形验证码
export function getCaptcha() {
  return request({
    url: '/sso/4.0/sso/image_captcha',
    method: 'post'
  })
}

// sso登录成功后二次校验
export function ticketLogin(data) {
  return request({
    url: '/ucenter/user/login/token.nse',
    method: 'post',
    data
  })
}

export function getUserByUsessionid(usessionid) {
  return request({
    url: '/ucenter/api/v1/user/getUserByUsessionid.nse',
    method: 'get',
    params: { usessionid }
  })
}

export function getUserResByUsessionid(userid) {
  return request({
    url: '/ucenter/adminUsers/hasPurchased/' + userid + '.nse',
    method: 'get',
    params: { }
  })
}

export function queryOrder(data) {
  return request({
    url: '/ucenter/pay/queryOrder.nse',
    method: 'get',
    params: data
  })
}

export function payapi(data) {
  return request({
    url: '/ucenter/pay/payapi.nse',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js